export default {

    setStorage(key, value) {
        localStorage.setItem(key, value)
    },
    getStorage(key) {
        return localStorage.getItem(key)
    },
    removeStorage(key) {
        localStorage.removeItem(key)
    },
    clearStorage() {

        localStorage.clear()
    },
    setSessionStorage(key, value) {
        sessionStorage.setItem(key, value)
    },
    getSessionStorage(key) {
        return sessionStorage.getItem(key)
    },
    removeSessionStorage(key) {
        sessionStorage.removeItem(key)
    },
    clearSessionStorage() {
        sessionStorage.clear()
    }
}


// WEBPACK FOOTER //
// ./src/utils/storage/baseStorage.js